import { useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const Password = () => {
  const [userInfo, setUserInfo] = useState({
    currentPassword: '',
    newPassword: '',
    checkNewPassword: ''
  });

  const onEnter = event => {
    if (event.keyCode === 13) {
      event.preventDefault();

      passWordChange();
    }
  };

  const passWordChange = () => {
    const userInfoMsgArr = [
      'Current password required.',
      'New password required.',
      'New password check required.'
    ];
    const userInfoColumn = [
      'currentPassword',
      'newPassword',
      'checkNewPassword'
    ];

    for (let i = 0; i < userInfoColumn.length; i++) {
      if (Common.isEmpty(userInfo[userInfoColumn[i]])) {
        Common.errorMsg(userInfoMsgArr[i]);

        return false;
      }
    }

    if (userInfo.newPassword !== userInfo.checkNewPassword) {
      Common.errorMsg('Please confirm the new password.');

      return false;
    }

    Server.sendPost('user/password', {
      userPassword: userInfo.currentPassword,
      newPassword: userInfo.newPassword
    }, passwordChangeCallback).then();
  };

  const passwordChangeCallback = () => {
    confirmAlert({
      title: 'Your password has been changed.',
      buttons: [{
        label: 'Yes',
        onClick: () => {
          document.location.href = '/home';
        }
      }]
    });
  };

  return (
    <>
      <VisualWrap>
        <Inner>
          <LoginBox>
            <LogoBox>
              <img src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/ust_logo.webp' alt='ust logo'/>
              <h4>Please set the password.</h4>
            </LogoBox>
            <LoginForm>
              <LoginInput
                type='password'
                id='currentPassword'
                name='currentPassword'
                autoComplete='off'
                placeholder='Current password'
                onKeyDown={(event) => {
                  onEnter(event);
                }}
                onChange={(e) => {
                  setUserInfo(() => {
                    return {
                      ...userInfo,
                      currentPassword: e.target.value,
                    };
                  });
                }}
              />
              <LoginInput
                type='password'
                id='newPassword'
                name='newPassword'
                autoComplete='off'
                placeholder='New password'
                onKeyDown={(event) => {
                  onEnter(event);
                }}
                onChange={(e) => {
                  setUserInfo(() => {
                    return {
                      ...userInfo,
                      newPassword: e.target.value,
                    };
                  });
                }}
              />
              <LoginInput
                type='password'
                id='CheckNewPassword'
                name='CheckNewPassword'
                autoComplete='off'
                placeholder='Check your new password'
                onKeyDown={(event) => {
                  onEnter(event);
                }}
                onChange={(e) => {
                  setUserInfo(() => {
                    return {
                      ...userInfo,
                      checkNewPassword: e.target.value,
                    };
                  });
                }}
              />
            </LoginForm>
            <LoginBtn onClick={passWordChange}>Check</LoginBtn>
          </LoginBox>
        </Inner>
      </VisualWrap>
    </>
  );
}

const VisualWrap = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/login_bg.webp') no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
  }
`;

const Inner = styled.div`
  z-index: 3;
  position: relative;
  max-width: 1200px;
`;

const LoginBox = styled.div`
  text-align: center;
`;

const LogoBox = styled.div`
  position: relative;

  & h4 {
    margin-top: 30px;
    color: white;
    font-size: 22px;
    font-weight: 600;
  }
`;

const LoginForm = styled.div`
  margin: 55px 0 60px;
  display: flex;
  flex-direction: column;
  gap: 18px 0;
`;

const LoginInput = styled.input`
  width: 320px;
  height: 45px;
  line-height: 45px;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  outline: none;
  border: none;
  font-weight: 500;
  font-size: 16px;
  color: #000000;

  &::placeholder {
    font-weight: 500;
    font-size: 16px;
    color: #777777;
  }
`;

const LoginBtn = styled.button`
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  background: #0072B9;
  border-radius: 100px;
`;

export default Password;